export const API_SERVICES = {
  BASE_API: 'base-api',
};
